<script setup>

import BaseInputLabeled from "@/Components/UI/inputs/BaseInputLabeled.vue";
defineProps({
    organization: {
        required: true,
        type: Object,
    }
})

</script>

<template>
    <div class="pt-5">
        <BaseInputLabeled :model-value="organization.name"
                          label="Название" required :disabled="true"/>
    </div>

    <div class="pt-5 grid grid-cols-2 gap-10">
        <BaseInputLabeled :model-value="organization.inn"
                          label="ИНН" required :disabled="true"/>
        <BaseInputLabeled :model-value="organization.ogrn"
                          label="ОГРН" :disabled="true"/>
    </div>
    <div class="pt-5 grid grid-cols-2 gap-10">
        <BaseInputLabeled :model-value="organization.okpo || ''"
                          label="ОКПО" :disabled="true"/>
        <BaseInputLabeled :model-value="organization.oktmo || ''"
                          label="ОКТМО" :disabled="true"/>
    </div>
    <div class="pt-5 grid grid-cols-2 gap-10">
        <BaseInputLabeled :model-value="organization.kpp || ''"
                          label="КПП" :disabled="true"/>
        <BaseInputLabeled :model-value="organization.email || ''"
                          label="Email" type="email" :disabled="true"/>
    </div>
    <div class="pt-5">
        <BaseInputLabeled :model-value="organization.legal_address || ''"
                          label="Юридический адрес" :disabled="true"/>
    </div>
</template>
